import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";

import ListDetailCard from "../../Components/Card/ListDetailCard";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { getAssignmentList } from "./Services";
import { getFormatedDate } from "../../Js/TimeAndDate";
import TopButton from "../../Components/UI/TopButtons";

const AssignList = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const listInnerRef = useRef();

  const paginationVal = 15;

  // State
  const [assignments, setAssignments] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [skipData, setSkipData] = useState(0);
  const [limitData, setLimitData] = useState(paginationVal);
  const [totalData, setTotalData] = useState(0);
  const [isFilter, setIsFilter] = useState(false);
  const [filterParams, setFilterParams] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // React logic hooks
  useEffect(() => {
    dispatch(commonSliceActions.setLoader(true));
    fetchAssignments();
    dispatch(assignmentSliceActions.resetState());
  }, []);

  useEffect(() => {
    const paginationRender = async () => {
      dispatch(commonSliceActions.setLoader(true));
      await fetchAssignments();
    };
    if (isFetching) {
      paginationRender();
    }
  }, [isFetching]);

  const handleFilter = async (params) => {
    setSkipData(0);
    setLimitData(paginationVal);
    setIsFilter(true);

    let query = {};

    if (params.assignmentName) {
      query.title = {
        $iLike: `%${params.assignmentName}%`,
      };
    }

    if (params.start_date && params.end_date) {
      query.createdAt = {
        $gt: params.start_date,
        $lt: params.end_date,
      };
    }
    setFilterParams(query);

    let resAssignmentData = await getAssignmentList(
      userInfo.uid,
      userInfo.site_uuid,
      0,
      paginationVal,
      query
    );

    console.log("resAssignmentData", resAssignmentData);
    setTotalData(resAssignmentData.data.total);
    setAssignments(resAssignmentData.data.data);
  };

  // Fetch Assignment Data
  const fetchAssignments = async () => {
    let assignmentData = await getAssignmentList(
      userInfo.uid,
      userInfo.site_uuid,
      skipData,
      limitData,
      isFilter ? filterParams : {}
    );

    setIsFetching(false);
    setIsLoading(false);
    dispatch(commonSliceActions.setLoader(false));
    if (skipData == 0) {
      setTotalData(assignmentData.data.total);
      setAssignments(assignmentData.data.data);
    } else {
      let newData = [...assignments, ...assignmentData.data.data];
      setAssignments(newData);
    }
  };

  // Route redirect function
  const goTo = (id) => {
    navigation(`/Assign/Info/${id}`);
  };

  const handleInfinityScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      let totalHeight = Math.ceil(scrollTop + clientHeight);
      if (
        totalHeight >= scrollHeight ||
        totalHeight == scrollHeight - 1 ||
        totalHeight === scrollHeight
      ) {
        return true;
      }
      return false;
    }
  };

  const handleLoadMore = () => {
    if (assignments && +assignments.length < +totalData) {
      setIsLoading(true);
    }
    setTimeout(() => {
      if (skipData / paginationVal < Math.ceil(totalData / paginationVal) - 1) {
        let totSkipData = skipData + limitData;
        console.log("totSkipData", totSkipData);
        setSkipData(() => totSkipData);
        setLimitData(() => limitData);
        setIsFetching(() => true);
      }
    }, 1000);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <TopButton
          title={assignments ? `${assignments.length}/${totalData}` : ``}
          centerText={isLoading ? "Loading..." : ""}
          isReportFilter={true}
          handleFilter={(params) => {
            handleFilter(params);
          }}
          classesHide={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
         
        ref={listInnerRef}
        sx={{ height: "79vh", overflow: isLoading ? "hidden" : "auto", mt: 1 }}
        onScroll={() => {
          if (handleInfinityScroll()) {
            handleLoadMore();
          }
        }}
      >
        <Grid>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 3,
                justifyContent: "flex-start",
                mt: 1,
                pl: 4,
                pb: 2,
              }}
            >
              {assignments &&
                assignments.length > 0 &&
                assignments.map((obj, index) => {
                  return (
                    <div key={`${index}_task`}>
                      <ListDetailCard
                        title={obj.title}
                        subheading={"Learners: " + obj.learners.learners.length}
                        leftBottomText={obj.is_exam ? "E-EXAM" : " "}
                        bottomText={"Due: " + getFormatedDate(obj.expiries)}
                        bottomExtraText={
                          "Created On: " + getFormatedDate(obj.createdAt)
                        }
                        line1={"Tasks: " + obj.tasks.tasks.length}
                        press={() => {
                          goTo(obj.uid);
                        }}
                      />
                    </div>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssignList;
